import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PlayerButton } from './PlayerButton';
export const PlayButton = React.memo(function PlayButton({ isPlaying, mediaElementId, onClick }) {
    return (_jsx(PlayerButton, { className: `hekate-player-play-btn ${isPlaying ? 'hekate-player-play-btn--playing' : ''}`, tooltip: isPlaying ? 'Pause' : 'Play', "aria-controls": mediaElementId, onClick: onClick }));
});
